import { getErrorMessage } from '@/shared/utils/error';

interface MotivoLoteApresentavel {
  /** Texto de negócio exibido ao operador. */
  texto: string;
  /** Mensagem crua do backend (enums internos), só como detalhe técnico. */
  detalhe: string | null;
}

const MOTIVOS_CONHECIDOS: Array<{ padrao: RegExp; texto: string }> = [
  { padrao: /^Status .* não permite esta ação/i, texto: 'A situação atual não permite esta ação' },
  { padrao: /^Citação ainda não entregue/i, texto: 'Citação ainda não entregue à parte' },
  { padrao: /^Citação por AR ainda em curso/i, texto: 'Citação por AR ainda em curso' },
  { padrao: /^Processo já tem árbitro ativo/i, texto: 'Processo já tem árbitro' },
  { padrao: /não está no ranking ativo/i, texto: 'Árbitro fora do ranking ativo da câmara' },
  {
    padrao: /sendo processado por outro lote/i,
    texto: 'Processo já está em outro lote em execução',
  },
  { padrao: /^Ação ainda não disponível/i, texto: 'Ação ainda não disponível' },
  {
    padrao: /manifestação viva — use 'certidao-decurso'/i,
    texto: 'Sem manifestação da parte — use a certidão de decurso',
  },
  {
    padrao: /manifestação viva — use 'escolher-certidao-lote'/i,
    texto: 'Há manifestação da parte — escolha o tipo de certidão',
  },
];

const TRECHO_TECNICO = /\s*\((?:[^()]*(?:=|esperado:)[^()]*)\)\s*$/;

/**
 * Traduz o motivo devolvido pelo backend para texto de negócio, mantendo a
 * mensagem crua como detalhe. Sem correspondência, apenas remove o parêntese
 * com enums internos (`(statusCitacaoRequerido=AGUARDANDO_ENVIO)`).
 */
export function apresentarMotivoLote(motivo: string): MotivoLoteApresentavel {
  const bruto = motivo.trim();
  if (bruto === '') return { texto: 'Sem detalhe informado', detalhe: null };

  const conhecido = MOTIVOS_CONHECIDOS.find((item) => item.padrao.test(bruto));
  if (conhecido) {
    return { texto: conhecido.texto, detalhe: conhecido.texto === bruto ? null : bruto };
  }

  const semTrechoTecnico = bruto.replace(TRECHO_TECNICO, '');
  if (semTrechoTecnico !== bruto && semTrechoTecnico !== '') {
    return { texto: semTrechoTecnico, detalhe: bruto };
  }

  return { texto: bruto, detalhe: null };
}

export function motivoAcaoLegivel(error: unknown, fallback?: string): string {
  return apresentarMotivoLote(getErrorMessage(error, fallback)).texto;
}
